import { render, staticRenderFns } from "./RabbeyTable3.vue?vue&type=template&id=3627e84e&scoped=true&"
import script from "./RabbeyTable3.vue?vue&type=script&lang=js&"
export * from "./RabbeyTable3.vue?vue&type=script&lang=js&"
import style0 from "./RabbeyTable3.vue?vue&type=style&index=0&id=3627e84e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627e84e",
  null
  
)

export default component.exports